var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright Laserfiche.
// Licensed under the MIT License. See LICENSE in the project root for license information.
import { createClientCredentialsAuthorizationJwt } from './AccessKey.js';
import { getOauthTokenUrl } from '../utils/DomainUtils.js';
import { ProblemDetails } from '../ProblemDetails.js';
import { ApiException } from '../ApiException.js';
import { BaseTokenClient } from '../BaseTokenClient.js';
/**
 * An object to interact with the Laserfiche Cloud OAuth 2.0 token endpoint.
 */
export class TokenClient extends BaseTokenClient {
    /**
     * Constructor for a TokenClient used to interact with the Laserfiche Cloud OAuth 2.0 token endpoint.
     * @param regionalDomain - regional specific host, such as 'laserfiche.com', or 'eu.laserfiche.com'
     */
    constructor(regionalDomain) {
        super();
        this._accessTokenSPErrMsg = "Get access token error.";
        this._baseUrl = getOauthTokenUrl(regionalDomain);
    }
    /**
     * Gets an OAuth access token given a Laserfiche cloud service principal key and an OAuth service application access key.
     * @param servicePrincipalKey - Laserfiche cloud service principal key
     * @param accessKey - OAuth service application access key
     * @param scope - OPTIONAL The requested space-delimited scopes for the access token.
     */
    getAccessTokenFromServicePrincipal(servicePrincipalKey, accessKey, scope) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const token = createClientCredentialsAuthorizationJwt(servicePrincipalKey, accessKey);
            let body = `grant_type=client_credentials`;
            if (scope) {
                body += `&scope=${encodeURIComponent(scope)}`;
            }
            const req = {
                method: 'POST',
                headers: new Headers({
                    'content-type': 'application/x-www-form-urlencoded',
                    withCredentials: 'true',
                    credentials: 'include',
                    Authorization: `Bearer ${token}`,
                }),
                body: body
            };
            const url = this._baseUrl;
            const res = yield fetch(url, req);
            if (res.status === 200) {
                const getAccessTokenResponse = yield res.json();
                return getAccessTokenResponse;
            }
            else if (((_a = res.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.includes('json')) === true) {
                const errorResponse = yield res.json();
                const problemDetails = ProblemDetails.fromJS(errorResponse);
                const apiException = new ApiException((_b = problemDetails.title) !== null && _b !== void 0 ? _b : this._accessTokenSPErrMsg, problemDetails.status, res.headers, problemDetails);
                throw apiException;
            }
            else {
                throw new ApiException(this._accessTokenSPErrMsg, res.status, res.headers, null);
            }
        });
    }
}
